import React from "react";
import { default as NoAvailableCasesIllustration } from "/public/assets/no-available-cases.svg?react";
import { default as NoAssignedCasesIllustration } from "/public/assets/no-assigned-cases.svg?react";
import { default as NoPatientsIllustration } from "/public/assets/no-patients.svg?react";
import { default as NoCompletedInservicesIllustration } from "/public/assets/no-completed-inservices.svg?react";
import { default as NoAvailableInservicesIllustration } from "/public/assets/no-available-inservices.svg?react";
import styled from "@emotion/styled";
import { AppButton } from "./Generic/AppButton";
import { keyframes } from "@emotion/react";
import { fmap } from "../utils/fmap";

const PlaceholderIllustrations = {
  NoAvailableCases: NoAvailableCasesIllustration,
  NoAssignedCases: NoAssignedCasesIllustration,
  NoPatients: NoPatientsIllustration,
  NoCompletedInservices: NoCompletedInservicesIllustration,
  NoAvailableInservices: NoAvailableInservicesIllustration,
};

type Props = {
  illustration?: keyof typeof PlaceholderIllustrations;
  headline: string;
  subheadline?: string;
  buttonText?: string;
  onClick?: () => void;
};

export default function ScreenPlaceholder(props: Props) {
  const Illustration = fmap(props.illustration, (x) => PlaceholderIllustrations[x]);

  return (
    <Root>
      {Illustration !== null && <IllustrationWrapper as={Illustration} />}
      <Content>
        <Headline>{props.headline}</Headline>
        <Subheadline>{props.subheadline}</Subheadline>
      </Content>
      {props.buttonText !== undefined && (
        <AppButton size="small" onClick={props.onClick}>
          {props.buttonText}
        </AppButton>
      )}
    </Root>
  );
}

const animation = keyframes`
  from {
    opacity: 0;
    transform: scale(0.95);  
  }
`;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  gap: 32px;
  animation: ${animation} 0.3s ease-in-out;
  max-width: 320px;
  margin: auto;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

const Headline = styled.h2`
  font-size: 22px;
  text-align: center;
  font-weight: 800;
  color: var(--tw-slate-900);
  margin: 0;
`;

const Subheadline = styled.p`
  font-size: 18px;
  text-align: center;
  font-weight: 400;
  color: var(--tw-slate-600);
  margin: 0;
`;

const IllustrationWrapper = styled.svg`
  --size: 160px;
  width: var(--size);
  height: var(--size);
`;
